import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function GamesCorner() {
  return <GameMap config={mapConfigs.gamesCorner} />;
}